export default __webpack_public_path__ + "static/media/ved.a8865ae0.jpeg";